module.exports = __webpack_public_path__ + "img/dtb@3x.20545676.png";